//===-----------------===
// Reusable functions
//===-----------------===

//===------- Toggle classes -------===//
function toggleClass(element, elementClass) {
  element.forEach((index) => {
    if (index) {
      if (index.classList.contains(elementClass)) {
        index.classList.remove(elementClass);
      } else {
        index.classList.add(elementClass);
      }
    }
  });
}

//===-----------------===
// Navigation
//===-----------------===
if (document.querySelector('.site-nav')) {
  let navBtn = document.querySelector('.site-nav__btn'),
    siteNav = document.querySelector('.site-nav');

  navBtn.addEventListener('click', function () {
    toggleClass(
      [siteNav, navBtn, document.querySelector('body')],
      'js-menu-open'
    );
    if (!siteNav.classList.contains('js-menu-open')) {
      siteNav.classList.add('js-menu-close');
      setTimeout(() => {
        siteNav.classList.remove('js-menu-close');
      }, 300);
    }
    if (!navBtn.classList.contains('js-menu-open')) {
      navBtn.classList.add('js-menu-close');
      setTimeout(() => {
        navBtn.classList.remove('js-menu-close');
      }, 300);
    }
    if (navBtn.getAttribute('aria-expanded') == 'false') {
      navBtn.setAttribute('aria-expanded', 'true');
    } else {
      navBtn.setAttribute('aria-expanded', 'false');
    }
  });

  navBtn.addEventListener('keyup', function (evt) {
    if (evt.code == 'Escape') {
      toggleClass(
        [siteNav, navBtn, document.querySelector('body')],
        'js-menu-open'
      );
    }
  });

  siteNav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('keyup', function (evt) {
      if (evt.code == 'Escape') {
        toggleClass(
          [siteNav, navBtn, document.querySelector('body')],
          'js-menu-open'
        );
      }
    });
  });

  //===-----------------===
  // Overlay - Menu close
  //===-----------------===
  if (document.querySelector('.overlay')) {
    document.querySelector('.overlay').addEventListener('click', function () {
      toggleClass(
        [siteNav, document.querySelector('body'), navBtn],
        'js-menu-open'
      );
      if (navBtn.getAttribute('aria-expanded') == 'false') {
        navBtn.setAttribute('aria-expanded', 'true');
      } else {
        navBtn.setAttribute('aria-expanded', 'false');
      }
      if (!navBtn.classList.contains('js-menu-open')) {
        navBtn.classList.add('js-menu-close');
        setTimeout(() => {
          navBtn.classList.remove('js-menu-close');
        }, 500);
      }
    });
  }
}

